import { devPaymentPfmConfig } from './config';
import type { CheckBillResponse, UsePaymentParams } from './types';

export const useFreedomPayment = ({
  billId,
  isDevRuntime,
  api,
  prodPay,
}: UsePaymentParams) => {
  const devCheckPayByBillId = () => {
    return api.client
      .post<CheckBillResponse>(
        '/check',
        { bill_id: billId },
        devPaymentPfmConfig,
      )
      .then(({ data }) => data);
  };

  const devPayByBillId = (amount: string) => {
    return api.client
      .post(
        '/pay',
        {
          amount,
          bill_id: billId,
          currency: 'KZT',
          paymentId: '37777777', // For development may be a random string
          provider_reference: '37777777', // For development may be a random string
        },
        devPaymentPfmConfig,
      )
      .then(({ data }) => data);
  };

  const devPay = () => {
    return devCheckPayByBillId()
      .then(({ amount }) => devPayByBillId(amount))
      .then(() => 'openTicketDetails'); // For dev payment always open details
  };

  const pay = isDevRuntime ? devPay() : prodPay(billId);

  return { pay };
};
